export default "__VITE_ASSET__BLWW_4YI__"